import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import CustomCard from '../../../components/CustomCard.tsx'
import DlgAddressSelector from './dlgAddressSelector.tsx'
import { useEffect, useState } from 'react'
import { MessageComponent } from '@syncfusion/ej2-react-notifications'
import DlgCreateAddress from './DlgCreateAddress.tsx'
import { INwDocentDto } from '../../../types/INwDocentDto.tsx'
import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks.tsx'
import { setSelectedDocent } from '../../../redux/docentSlice.tsx'

const SemiAddressAssignment = () => {
  const [isDlgSelectAdrVisible, setIsDlgSelectAdrVisible] = useState(false)
  const [isDlgCreateAdrVisible, setIsDlgCreateAdrVisible] = useState(false)
  const [color, setColor] = useState('white')

  const dispatch = useAppDispatch()
  const selectedProfile = useAppSelector((state) => state.register.selectedRegistration)

  const [msgContent, setMsgContent] = useState('')

  // Adresse wählen: Returnwert adrId in Form setzen
  const handleDlgSelectAdrSaveClose = (lecturerRecord: INwDocentDto | null) => {
    if (lecturerRecord) {
      // wird in Profile.tsx per useEffect in form resetted
      dispatch(setSelectedDocent(lecturerRecord))
    }

    setIsDlgSelectAdrVisible(false)
  }

  // Adresse wählen: Dialog schließen
  const handleDlgSelectAdrCancel = () => {
    setIsDlgSelectAdrVisible(false)
  }

  // Adresse erstellen: Return
  const handleDlgCreateAdrSaveClose = () => {
    setIsDlgCreateAdrVisible(false)
  }

  // Adresse erstellen: Dialog schließen
  const handleDlgCreateAdrCancel = () => {
    setIsDlgCreateAdrVisible(false)
  }

  useEffect(() => {
    console.log(selectedProfile)
    if (selectedProfile?.adrId === null || selectedProfile?.adrId === undefined) {
      setMsgContent(
        'Bitte eine Adresse auswählen.',
      )
      setColor('red')
    } else {
      setMsgContent(
        `Adresse: <b>${selectedProfile?.adrNo}</b>`,
      )
      setColor('#16A390')
    }
  }, [selectedProfile])


  return (
    <>
      <CustomCard header={'Daten aus der Seminarverwaltung'} style={{ borderTop: `3px solid ${color}` }}>
        <div>
          <MessageComponent content={msgContent} severity="Information" variant="Outlined" style={{ marginBottom: '20px', display: 'inline-flex' }}></MessageComponent>
        </div>

        <ButtonComponent isPrimary type={'button'} content={'Adresse Suchen'} iconCss="e-icons e-search" onClick={() => setIsDlgSelectAdrVisible(true)} style={{ marginRight: '10px' }}></ButtonComponent>
        <ButtonComponent type={'button'} content={'Neue Adresse anlegen'} iconCss="e-icons e-plus" onClick={() => setIsDlgCreateAdrVisible(true)}></ButtonComponent>
      </CustomCard>

      <DlgAddressSelector visible={isDlgSelectAdrVisible} onClose={handleDlgSelectAdrSaveClose} onCancel={handleDlgSelectAdrCancel} />
      <DlgCreateAddress visible={isDlgCreateAdrVisible} onClose={handleDlgCreateAdrSaveClose} onCancel={handleDlgCreateAdrCancel} />
    </>
  )
}

export default SemiAddressAssignment
